import * as React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import ProjectSetUpPageStore from '~/client/src/desktop/views/ProjectSetUp/ProjectSetUpPage.store'

import ISetUpStep from './ISetUpStep'

interface ISetUpNavigationSubStepProps extends ISetUpStep {
  step: ISetUpStep
  projectSetUpPageStore: ProjectSetUpPageStore
  isShortVersion?: boolean
  onClick?: () => void
}

@observer
export default class SetUpNavigationSubStep extends React.Component<ISetUpNavigationSubStepProps> {
  public render() {
    const { getTitle, step, projectSetUpPageStore, isShortVersion } = this.props

    const title = getTitle()
    const isAllowed = projectSetUpPageStore.isAllowedToNavigate(step.page)
    const current = projectSetUpPageStore.currentPage === step.page

    return (
      <div
        onClick={this.navigateTo}
        className={classList({
          'col substep text line-40 y-center': true,
          pointer: isAllowed,
          'inactive-element': !isAllowed,
        })}
      >
        <div
          className={classList({
            'navigation-row-title row': true,
            'ml25 pl12 bl-input-border': !isShortVersion,
          })}
        >
          <div
            className={classList({
              'title-text px10 brada4 hoverable-page-bg': true,
              'current-page-bg default-cursor': current,
              ml4: isShortVersion,
            })}
          >
            {title}
          </div>
        </div>
      </div>
    )
  }

  private navigateTo = () => {
    const { projectSetUpPageStore, step, onClick } = this.props
    projectSetUpPageStore.navigateTo(step.page)
    onClick?.()
  }
}
